import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TimelineUserRowContextMenuWrapperService } from './timeline-user-row-context-menu-wrapper.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ShiftTemplateSelectComponent } from '../../../components/shift-template-select/shift-template-select.component';
import { firstValueFrom, filter } from 'rxjs';

@Component({
  selector: 'wilson-timeline-user-row-context-menu-wrapper',
  imports: [NzDropDownModule, TranslateModule],
  templateUrl: './timeline-user-row-context-menu-wrapper.component.html',
  styleUrl: './timeline-user-row-context-menu-wrapper.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimelineUserRowContextMenuWrapperComponent {
  private translateService = inject(TranslateService);
  private nzModalService = inject(NzModalService);
  protected timelineUserRowContextMenuWrapperService = inject(
    TimelineUserRowContextMenuWrapperService,
  );

  protected async openShiftTemplateSelectionModalAndCreate() {
    const modalRef = this.nzModalService.create({
      nzTitle: this.translateService.instant(
        'page.shift_timeline.shift_templates_tab',
      ),
      nzContent: ShiftTemplateSelectComponent,
      nzClosable: true,
      nzCentered: true,
      nzFooter: null,
      nzWidth: 250,
    });

    if (modalRef.componentInstance) {
      const selectedShiftTemplate = await firstValueFrom(
        modalRef.componentInstance.selectedShiftTemplateChange.pipe(
          filter((template) => !!template),
        ),
      );
      modalRef.destroy();
      //Prevent blocking task
      setTimeout(() => {
        this.timelineUserRowContextMenuWrapperService.createShiftFromTemplate(
          selectedShiftTemplate,
        );
      });
    }
  }
}
